import type { Components, Theme } from "@mui/material/styles";

export const MuiIcon: Components<Theme>["MuiIcon"] = {
  styleOverrides: {
    root: {
      display: "inline-grid",
      placeItems: "center",

      "& > .MuiSvgIcon-root": {
        width: "100%", // the SVG should get the width & height from the <Icon> wrapper component
        height: "100%",
      },
    },
  },
};
